/** Fallback Kie preset id (female) — only used if validation is bypassed. */
export const DEFAULT_KLING_STITCH_VOICE = {
  id: "hpp4J3VqNfWAUOO0d1Us",
  label: "Bella — bright, warm",
};

/**
 * Resolve locked voice for multi-segment stitched generation.
 * @param {object} form
 */
export function resolveStitchVoiceLock(form) {
  if (form.sound === false) return null;

  const voiceSource = form.voiceSource || "ai";

  if (voiceSource === "preset" && String(form.klingVoicePreset || "").trim()) {
    return {
      mode: "preset",
      id: String(form.klingVoicePreset).trim(),
      label: String(form.klingVoiceLabel || "").trim(),
    };
  }

  if (voiceSource === "upload") {
    const hasUpload = (form.referenceAudioUploads || []).some((u) => u?.file || u?.previewUrl);
    if (hasUpload) {
      return { mode: "upload-seed" };
    }
  }

  return { mode: "ai", autoLocked: true };
}
